import React, { useState, useEffect } from 'react';
import { ItemList } from './ItemList';
import { extractSuffixFromField, sendRequest } from "./vmUtils";
import { lambdaURL } from "../config";
import { useAuth } from './vmAuthenticate';


export const VMDelegation = ({ assembly_uuid, onViewProfile }) => {
  const [delegations, setDelegations] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState('');
  const [selectedDelegate, setSelectedDelegate] = useState('');
  const [voters, setVoters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuth();
  const userId = user.userId;

  useEffect(() => {
    fetchDelegations();
    fetchTopics();
    fetchVoters();
  }, [assembly_uuid]);

  const fetchDelegations = async () => {
    const jsonData = {
      command: "getDelegationsForAssembly",
      assemblyId: assembly_uuid
    };

    sendRequest(lambdaURL, jsonData)
    .then(data => {
      if (data.body) {
        const parsedBody = JSON.parse(data.body);
        if (parsedBody && Array.isArray(parsedBody)) {
          setDelegations(parsedBody);
          setIsLoading(false);
        }
      }
    });
  };

  const fetchTopics = async () => {
    const jsonData = {
      command: "getTopicsForAssembly",
      assemblyId: assembly_uuid
    };
    
    sendRequest(lambdaURL, jsonData)
    .then(data => {
      if (data.body) {
        const parsedBody = JSON.parse(data.body);
        if (parsedBody && Array.isArray(parsedBody)) {
          setTopics(parsedBody);
        }
      }
    });
  };

  const fetchVoters = async () => {
    const jsonData = {
      command: "getAssemblyMembers",
      assemblyId: assembly_uuid
    };
    
    sendRequest(lambdaURL, jsonData)
    .then(data => {
      if (data.body) {
        const parsedBody = JSON.parse(data.body);
        if (parsedBody && Array.isArray(parsedBody)) {
          console.log("Setting voters:", parsedBody);
          setVoters(parsedBody);
        }
      }
    });
  };

  const handleCreateDelegation = async () => {
    if (!selectedTopic || !selectedDelegate) return;

    const jsonData = {
      command: "createDelegation",
      delegateId: selectedDelegate,
      assemblyId: assembly_uuid,
      topicId: selectedTopic
    };
    
    sendRequest(lambdaURL, jsonData)
    .then(data => {
      if (data.body) {
        fetchDelegations();
        setSelectedTopic('');
        setSelectedDelegate('');
      }
    });
  };

  const handleRevokeDelegation = async (delegationId) => {
    const jsonData = {
      command: "revokeDelegation",
      uuid: delegationId
    };
    
    sendRequest(lambdaURL, jsonData)
    .then(data => {
      if (data.body) {
        fetchDelegations();
      }
    });
  };

  const renderDelegationItem = (delegation) => (
    <div className="vm-item-container">
      <div className="vm-item-content">
        <div className="vm-item-title">
          Topic: {delegation.topicName}
        </div>
        <div className="vm-item-description">
          Delegated to: {delegation.delegateName}
        </div>
      </div>
      <button 
        className="vm-base-shadow-button-14"
        onClick={() => handleRevokeDelegation(extractSuffixFromField(delegation.SK, 'DELEGATION'))}
      >
        Revoke
      </button>
    </div>
  );

  if (isLoading) {
    return <div className="vm-loading">Loading delegations...</div>;
  }

  return (
    <div className="vm-section">
      <div className="vm-section-sub-header">
        <b>My Delegations</b>
      </div>

      <div className="vm-form-vertical">
        <div className="vm-form-row">
          <select
            className="vm-form-input vm-form-input-half"
            value={selectedTopic}
            onChange={(e) => setSelectedTopic(e.target.value)}
          >
            <option value="">Select a topic</option>
            {topics.map(topic => (
              <option key={topic.SK.replace('TOPIC#', '')} value={topic.SK.replace('TOPIC#', '')}>
                {topic.name}
              </option>
            ))}
          </select>

          <select
            className="vm-form-input vm-form-input-half"
            value={selectedDelegate}
            onChange={(e) => setSelectedDelegate(e.target.value)}
          >
            <option value="">Select a delegate</option>
            {voters.filter(voter => voter.PK.replace('USER#', '') !== userId).map(voter => (
              <option key={voter.PK.replace('USER#', '')} value={voter.PK.replace('USER#', '')}>
                {voter.PK.replace('USER#', '')}
              </option>
            ))}
          </select>
          {selectedDelegate && (
            <button
              className="vm-base-shadow-button-14"
              onClick={() => {
                const selectedVoter = voters.find(v => v.PK.replace('USER#', '') === selectedDelegate);
                onViewProfile(selectedVoter);
              }}
            >
              View Profile
            </button>
          )}

        </div>
        <button 
          onClick={handleCreateDelegation}
          disabled={!selectedTopic || !selectedDelegate}
        >
          Create Delegation
        </button>
      </div>

      <ItemList
        items={delegations}
        onItemClick={() => {}}
        titleField="topicName"
        descriptionField="delegateName"
        idField="uuid"
        emptyMessage="No active delegations"
        renderItem={renderDelegationItem}
      />
    </div>
  );
};

          //className="vm-form-button"